import AllReviews, { AllReviewsProps } from './AllReviews'

export default AllReviews

export { AllReviews }
export type { AllReviewsProps }
